export const HEADER = 'header';
export const GENERAL_DATA = 'generaldata';
